import type { FaireProductEntity } from "../../entity_types/product";

export const p_5vu68sbevx: FaireProductEntity = {
  token: "p_5vu68sbevx",
  type: "product",
  name: "Bigfoot Doorbell, Rustic Cast Iron Sasquatch Porch Bell",
  brandName: "Iron & Blossom",
  imageUrl:
    "https://cdn.faire.com/fastly/44aec747bf97e1d03db92d65f98934171dc99d882d5505fc1e9d7ed505548050.png",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/df2bb9a3d6d724ed0d5b18a0513de3c54099c07a1ed3104c37d3acee0f045b37.png",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
